export default __webpack_public_path__ + "static/SunExpress_Pressemeldung_1_1_de-34e57d59fa418b415c06a7fbce63ca16.png";